import {addLoader, apiSlice, asyncToastDisplay, i18n} from "./apiSlice";

export const dmpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDmps: builder.query({
      query: () => (`/dmps`),
      providesTags: (result , error, arg) => [{ type: 'Dmp', id: "LIST"}],
    }),
    getDmpAdapters: builder.query({
      query: () => (`/dmps/adapters`),
    }),
    createDmp: builder.mutation({
      query: ({dmp}) => ({
        url: `/dmps/`,
        method: 'POST',
        body: dmp
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{ type: 'Dmp', id: "LIST"}],
    }),
    updateDmp: builder.mutation({
      query: ({dmp}) => ({
        url: (`/dmps/${dmp.dmpId}`),
        method: 'PUT',
        body: dmp,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {dmp}) => [{ type: 'Dmp', id: "LIST"}, { type: 'Dmp', id: dmp.dmpId }],
    }),
    deleteDmp: builder.mutation({
      query: (dmpId) => ({
        url: (`/dmps/${dmpId}`),
        method: 'DELETE'
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, {dmpId}) => [{ type: 'Dmp', id: "LIST"}, { type: 'Dmp', id: dmpId }],
    }),
    pushDmp: builder.mutation({
      query: (dmp) => ({
        url: (`/dmps/${dmp.slug}/push`),
        method: 'POST',
        body: dmp
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.pushed")}),
    }),
  }),
  overrideExisting: false
})

export const {
  useGetDmpsQuery,
  useGetDmpAdaptersQuery,
  useCreateDmpMutation,
  useUpdateDmpMutation,
  useDeleteDmpMutation,
  usePushDmpMutation,
} = dmpApiSlice;
